import { BreakdownServiceAuthorType, CustomerType, PhoneNumber, SelfServiceType } from 'modules/selfServices/types/SelfService';
import { ConnectionTypeLogin, SelfOfficeLoginMethod } from 'modules/dealers/types/ContextResponse';
import { LoginData } from 'modules/auth/types/InitialState';

export enum ChannelEnum {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
  WHATSAPP = 'WHATSAPP',
}

export enum QrCodeLoginMethod {
  QR_CODE = 'QR_CODE',
  MANUAL_CODE = 'MANUAL_CODE',
}


// Frontend-only extension — never sent to the API
export enum AdditionalChannelEnum {
  SMS_ADDITIONAL = 'SMS_ADDITIONAL',
  EMAIL_ADDITIONAL = 'EMAIL_ADDITIONAL',
  WHATSAPP_ADDITIONAL = 'WHATSAPP_ADDITIONAL',
}

export type UIChannelEnum = ChannelEnum | AdditionalChannelEnum;

export enum WhatsAppStatusEnum {
  REACHABLE = 'REACHABLE',
  UNREACHABLE = 'UNREACHABLE',
}

export enum MfaScopeEnum {
  REOPEN = 'REOPEN',
}

export interface LoginRequest {
  locationId?: number;
  type?: SelfOfficeLoginMethod;
  value?: Partial<PhoneNumber> | string;
}

export interface GetMFAConnectionRequest {
  value?: string;
  registration?: string;
  brandId?: string;
  dealerId?: string;
  phoneNumber?: string;
  scope?: MfaScopeEnum;
  type?: SelfServiceType;
  searchType?: SelfOfficeLoginMethod;
}

export type LoginParams = LoginData & {
  type?: SelfServiceType;
  connectionTypes?: ConnectionTypeLogin[];
  searchType?: SelfOfficeLoginMethod.PHONE_NUMBER | SelfOfficeLoginMethod.REGISTRATION
};

export interface SendMFACodeRequest {
  connectionId: string;
  selfServiceId: string;
  channel?: ChannelEnum;
  customerType?: CustomerType
}

export interface SendQrCodeRequest {
  qrCode: string;
  type: SelfServiceType;
  loginMethod?: QrCodeLoginMethod;
}

export interface LoginMFARequest {
  connectionId: string;
  selfServiceId: string;
  code: string;
  breakdownServiceAuthorType?: BreakdownServiceAuthorType;
}

export interface SendAdminCodeRequest {
  kioskId: string;
  pinCode: string;
  qrCodeToken: string;

}

export interface CheckQRCodeTokenRequest {
  qrCodeToken: string;
  kioskId: string;
}
